import React, { Component } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { CharacterItem } from "../../components/characters/CharacterItem";

export interface CharacterItemSliderProps
{
    onItemSelected: (item: CharacterItem) => void;
    items: Array<CharacterItem>;
    activeItems: Array<CharacterItem>;
}

interface CharacterItemSliderState 
{
    selected: CharacterItem;
}

export class CharacterItemSlider extends Component<CharacterItemSliderProps, CharacterItemSliderState>
{
    private swiper: any = null;

    constructor(props: CharacterItemSliderProps)
    {
        super(props);

        this.state = {
            selected: null
        };
    }

    private onClick(selected: CharacterItem, index: number): void 
    {
        // this.swiper.slideTo(index);

        this.setState({
            selected
        });

        this.props.onItemSelected(selected);
    }

    private checkActive(item: CharacterItem): boolean
    {
        for (let i = 0; i < this.props.activeItems.length; i++)
        {
            let activeItem = this.props.activeItems[i];

            if (activeItem.id === item.id)
            {
                return true;
            }
        }
        return false;
    }

    private buildItems(): Array<JSX.Element>
    {
        let items = [];

        for (let i = 0; i < this.props.items.length; i++)
        {
            let item: CharacterItem = this.props.items[i];
            let isActive: boolean = this.checkActive(item);

            items.push(
                <SwiperSlide key={"slide_" + item.id}>
                    <div key={item.id} className={"item" + (isActive ? " selected" : "")}
                        onClick={this.onClick.bind(this, item, i)}>
                        <img src={item.src} alt="Ice cream" />
                    </div>
                </SwiperSlide >
            );
        }

        return items;
    }

    public render(): JSX.Element
    {
        return (
            <>
                <Swiper
                    spaceBetween={8}
                    slidesPerView={3.5}
                    onSwiper={(swiper) => this.swiper = swiper}
                >
                    {this.buildItems()}
                </Swiper>
            </>
        );
    }
}